import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

export const LANG_COLORS = {
  fr: "#002FA7", de: "#D97706", en: "#16A34A", it: "#DC2626",
  es: "#7C3AED", pt: "#0EA5E9", nl: "#64748B",
};

export function buildLangHistory(history) {
  const points = (history || [])
    .filter((a) => a.scoring?.by_language)
    .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
    .map((a) => {
      const row = { date: new Date(a.created_at).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) };
      Object.entries(a.scoring.by_language).forEach(([code, ls]) => {
        if (ls.score !== null && ls.score !== undefined) row[code] = ls.score;
      });
      return row;
    });
  const langs = [...new Set(points.flatMap((r) => Object.keys(r).filter((k) => k !== "date")))].sort();
  return { points, langs };
}

export function LanguageScoreHistory({ history }) {
  const { points, langs } = buildLangHistory(history);
  if (points.length < 2) {
    return (
      <div className="mt-3 text-[11px] text-slate-400" data-testid="language-history-pending">
        L&apos;évolution du score par langue se tracera au fil des audits (2 audits minimum).
      </div>
    );
  }
  return (
    <div className="mt-4 border-t border-slate-100 pt-3" data-testid="language-history-chart">
      <div className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider mb-2">Évolution par langue</div>
      <div className="h-36">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={points} margin={{ top: 5, right: 12, left: -22, bottom: 0 }}>
            <XAxis dataKey="date" tick={{ fontSize: 10, fill: "#94A3B8" }} />
            <YAxis domain={[0, 100]} tick={{ fontSize: 10, fill: "#94A3B8" }} />
            <Tooltip formatter={(v, name) => [`${v}/100`, String(name).toUpperCase()]}
              labelFormatter={(l) => `Audit du ${l}`} contentStyle={{ fontSize: 12 }} />
            {langs.map((code) => (
              <Line key={code} type="monotone" dataKey={code} stroke={LANG_COLORS[code] || "#64748B"}
                strokeWidth={2} dot={{ r: 3 }} connectNulls />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="flex gap-3 mt-1" data-testid="language-history-legend">
        {langs.map((code) => (
          <span key={code} className="inline-flex items-center gap-1 text-[11px] text-slate-600">
            <span className="w-2.5 h-2.5 rounded-full" style={{ background: LANG_COLORS[code] || "#64748B" }} />
            {code.toUpperCase()}
          </span>
        ))}
      </div>
    </div>
  );
}
